import { React, useState } from "react";
import { Badge, Button, Col, Form, Row } from "react-bootstrap";
import { AsyncPaginate } from "react-select-async-paginate";
import api from "../../../../service/api";
import { Filter } from "react-feather";
import Select from "react-select";
import { addDefaultOption } from "../../../../utils/utility";
import { minSelectableYear } from "../../../../utils/EnrolmentSummaryConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from "@fortawesome/free-regular-svg-icons";
import moment from "moment";
import { DatePicker } from "antd";

const Search = ({ setSearchValue, companies, searchValue, onSearch, salesPersons }) => {
    const [hasMore, setHasMore] = useState(true);
    const handleLoadMore = async (search, { page }) => {
        if (!search) {
            return {
                options: [],
                hasMore: false,
            };
        }

        const response = await api.get("tms/companies-options", {
            search: search,
            page: page,
        });

        const { options: newOptions, hasMore: newHasMore } = response;

        setHasMore(newHasMore);

        return {
            options: newOptions,
            hasMore: newHasMore,
            additional: {
                page: page + 1,
            },
        };
    };
    return (
        <Row className="py-3">
            <Col md={2} className="mb-2 align-self-center">
                <Form.Control
                    type="text"
                    name="number"
                    placeholder="Transaction ID"
                    size="lg"
                    onChange={(event) => {
                        setSearchValue({
                            ...searchValue,
                            transaction_id: event.target.value,
                        });
                    }}
                />
            </Col>

            <Col md={3} className="mb-2">
                <Select
                    menuPortalTarget={document.body} // This moves the menu to the body tag
                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Ensure it's on top
                    className={`react-select-container`}
                    classNamePrefix="react-select"
                    placeholder="Status"
                    options={addDefaultOption([
                        { label: "OPEN", value: "OPEN" },
                        { label: "PARTIAL-PAID", value: "PARTIAL-PAID" },
                        { label: "CLOSED", value: "CLOSED" },
                        { label: "OVERPAID", value: "OVERPAID" },
                    ])}
                    isClearable={true}
                    onChange={(selectedOption) => {
                        setSearchValue({
                            ...searchValue,
                            status: selectedOption ? selectedOption?.value : "",
                        });
                    }}
                />
            </Col>

            <Col md={3} className="mb-2 align-self-center">
                <AsyncPaginate
                    isClearable
                    loadOptions={handleLoadMore}
                    hasMore={hasMore}
                    placeholder="Search company"
                    additional={{
                        page: 1,
                    }}
                    onChange={(value) => {
                        setSearchValue({
                            ...searchValue,
                            company: value ? value?.value : "",
                        });
                    }}
                    debounceTimeout={1000}
                />
            </Col>
            <Col md={3}>
                    <Select
                        menuPortalTarget={document.body} // This moves the menu to the body tag
                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Ensure it's on top
                        className="is-invalid react-select-container"
                        classNamePrefix="react-select"
                        options={addDefaultOption(salesPersons)}
                        name="salesperson"
                        placeholderText={`Select salesperson`} 
                        onChange={(value) => {
                            setSearchValue({
                                ...searchValue,
                                salesperson: value
                                    ? value?.value
                                    : "",
                            });
                        }}
                    />
                </Col>
            <Col md={4} className="mb-2 align-self-center">
                <Row className="flex-row ms-md-1">
                    <Col md={5} className="p-md-0">
                        <DatePicker
                            id="from-date-picker"
                            name="from_date"
                            className={`form-control`}
                            placeholder="From Payment Date"
                            // defaultValue={moment().startOf('month')}
                            // allowClear={false}
                            onChange={(event) => {
                                setSearchValue({
                                    ...searchValue,
                                    start_date: event
                                        ? moment(event).format("YYYY-MM-DD")
                                        : null,
                                });
                            }}
                            style={{ minHeight: "2.5rem" }}
                        />
                    </Col>
                    <Col
                        md={2}
                        className="d-flex align-items-center justify-content-center m-0 p-0"
                    >
                        <Badge
                            bg="info"
                            className="d-flex align-items-center justify-content-center text-center w-100 h-100 mx-2 mx-md-0"
                        >
                            To
                        </Badge>
                    </Col>
                    <Col md={5} className="p-md-0">
                        <DatePicker
                            id="to-date-picker"
                            name="to_date"
                            className={`form-control`}
                            placeholder="To Payment Date"
                            // defaultValue={moment().endOf('month')}
                            // allowClear={false}
                            onChange={(event) => {
                                setSearchValue({
                                    ...searchValue,
                                    end_date: event
                                        ? moment(event).format("YYYY-MM-DD")
                                        : null,
                                });
                            }}
                            style={{ minHeight: "2.5rem" }}
                        />
                    </Col>
                </Row>
            </Col>

             <Col md={4} className="mb-2 align-self-center">
                <Row className="flex-row ms-md-1">
                    <Col md={5} className="p-md-0">
                        <DatePicker
                            id="from-date-picker"
                            name="from_submitted_date"
                            className={`form-control`}
                            placeholder="From Submitted Date"
                            onChange={(event) => {
                                setSearchValue({
                                    ...searchValue,
                                    submitted_from: event
                                        ? moment(event).format("YYYY-MM-DD")
                                        : null,
                                });
                            }}
                            style={{ minHeight: "2.5rem" }}
                        />
                    </Col>
                    <Col
                        md={2}
                        className="d-flex align-items-center justify-content-center m-0 p-0"
                    >
                        <Badge
                            bg="info"
                            className="d-flex align-items-center justify-content-center text-center w-100 h-100 mx-2 mx-md-0"
                        >
                            To
                        </Badge>
                    </Col>
                    <Col md={5} className="p-md-0">
                        <DatePicker
                            id="to-date-picker"
                            name="to_submitted_date"
                            className={`form-control`}
                            placeholder="To Submitted Date"
                            onChange={(event) => {
                                setSearchValue({
                                    ...searchValue,
                                    submitted_to: event
                                        ? moment(event).format("YYYY-MM-DD")
                                        : null,
                                });
                            }}
                            style={{ minHeight: "2.5rem" }}
                        />
                    </Col>
                </Row>
            </Col>





            <Col
                md={2}
                className="mb-2 align-self-center d-flex justify-content-md-start justify-content-center"
            >
                <Button
                    className="ms-2"
                    size="lg"
                    variant="info"
                    onClick={onSearch}
                >
                    <Filter size={15} />
                </Button>
            </Col>
        </Row>
    );
};
export default Search;
